import './BrowserNotSupported.scss';
import React from "react";
import logo_fa from "../../assets/images/logo_fa.svg";
import T from "../../shared/component/t/T";
import Footer from "../Panel/Footer/footer";

export default function BrowserNotSupported(props) {
    return (
        <>
            <div className={"BrowserNotSupported"} style={{
                backgroundImage: `url(/common/img/broken.jpg)`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
            }}>
                <div className={"center"} >
                    <div className={"logo"}>
                        <img  src={logo_fa}  alt="" />
                    </div>
                    <div className={"text"}>
                        <T token={"old_browsers_does_not_support"}/>
                    </div>
                </div>
            </div>
            <Footer />
        </>

    )
};

